import { render, staticRenderFns } from "./CompanyNotifications.vue?vue&type=template&id=63512b3e&scoped=true"
import script from "./CompanyNotifications.vue?vue&type=script&lang=js"
export * from "./CompanyNotifications.vue?vue&type=script&lang=js"
import style0 from "./CompanyNotifications.vue?vue&type=style&index=0&id=63512b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63512b3e",
  null
  
)

export default component.exports